import { fontStyles } from '@/styles/typography';

import { AlertCircleIcon } from '@/ui/Icons/AlertCircleIcon';

import { SwapTransactionAlertMessages } from '../../../../utils/errors';
import { InlineAlertBox } from '../InlineAlertBox';

interface Props {
  alertType: keyof typeof SwapTransactionAlertMessages;
  tokenSymbol?: string;
}

export const SwapTransactionAlert = ({ alertType, tokenSymbol }: Props) => {
  const alertMessages: {
    readonly level: 'error' | 'info';
    readonly headerMessage: string;
    readonly bodyMessage: string | null;
  } = SwapTransactionAlertMessages[alertType];
  const isOneLineAlert = !alertMessages.bodyMessage;

  if (alertMessages.level === 'info') {
    return (
      <InlineAlertBox
        level="info"
        title={alertMessages.headerMessage}
        description={
          <>
            {tokenSymbol}
            {alertMessages.bodyMessage}
          </>
        }
      />
    );
  }

  return (
    <div
      className={fontStyles({
        variant: 'LABEL_MD',
        class: [
          'text-token-red-1300',
          'bg-token-red-300',
          'stroke-token-red-900',
          'block',
          isOneLineAlert ? 'py-2.5 px-3 rounded-[88px]' : 'py-4 px-4 rounded-md',
        ],
      })}
    >
      <div className="flex justify-start">
        <AlertCircleIcon className="justify-center" />
        <span className="justify-center ml-2">{alertMessages.headerMessage}</span>
      </div>
      {alertMessages.bodyMessage && (
        <span
          className={fontStyles({
            variant: 'BODY_MD',
            class: ['text-token-red-1300', 'flex', 'justify-start', 'mt-2'],
          })}
        >
          {tokenSymbol}
          {alertMessages.bodyMessage}
        </span>
      )}
    </div>
  );
};
